/* eslint-disable camelcase */
  <template >
  <div v-role="'func'">
  <div>
  <div class="formPosition">

    <!-- ============================== DIALOGO DO FORNECEDOR ========================================== -->
  <v-dialog v-model="dialogFornecedor" width="800px">
      <template >

        <v-container  style="background-color:#006699; color:white; ">
            <div>
              <span>Novo Fornecedor</span>
            </div>
        </v-container>
      <v-form
          ref="form"
          v-model="valid"
          lazy-validation
      >
            <v-card width="800px">
              <v-alert
                v-model="alertF"
                dismissible
                :type="alertType"
                border="left"
                :icon="iconAlert"
                transition="scale-transition"
                :style="colorAlert"
                elevation="2"
                colored-border
              >
              {{msgAlert}}
            </v-alert>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="8">
                      <v-text-field v-model="editedItemFornecedor.nome" :rules="ruleRequired" label="Nome Completo" ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="editedItemFornecedor.nif" :rules="ruleRequired" label="NIF" ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-select
                          :items="tipoFornecedor"
                          item-text="descricao"
                          item-value="descricao"
                          v-model="editedItemFornecedor.tipoFornecedor"
                          :rules="ruleRequired"
                          filled
                          label="Tipo de Fornecedor"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="editedItemFornecedor.morada" :rules="ruleRequired"  label="Morada" ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="editedItemFornecedor.telefone1" :rules="ruleRequired" label="Telefone 1" ></v-text-field>
                    </v-col>
                      <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="editedItemFornecedor.email" :rules="ruleRequired" label="Email" ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn style="color:white;" :disabled="!valid" color="green darken-1"   @click="SaveFornecedor()">Guardar</v-btn>
                <v-btn style="color:white;"   color="red darken-1"   @click="dialogFornecedor = false">Fechar</v-btn>
              </v-card-actions>
            </v-card>
        </v-form>

      </template>
  </v-dialog>

    <!-- ==================================================================================================-->
  <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
<v-form
    ref="form"
    v-model="valid"
    lazy-validation
>
  <v-row>
      <v-card style="margin:auto;margin-top:10px;" width="1200px">

        <v-card-title style="background-color:#006699;color:white;">
          <v-row>
           <v-col md="9"><span>Nova Factura</span></v-col>
           <v-col md="2">
             <v-btn color="white" @click="$router.push('Visualizar-Faturas')" style="color:#006699;">Consultar Facturas</v-btn>
           </v-col>
            <v-col md="1">
              <v-icon style="float:right;" v-if="this.$store.state.fromStock" @click="back()" color="primary">arrow_back</v-icon>
              <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs"
                  v-on="on" style="float:right;color:white;">info</v-icon>
              </template>
              <span>Clique aqui para saber como criar um novo Produto</span>
            </v-tooltip>
            </v-col>
         </v-row>
 </v-card-title>
        <v-alert
          v-model="alert"
          dismissible
          close-icon="remove"
          color="green"
          border="left"
          elevation="2"
          colored-border
          icon="done"
        >
      <strong>Factura</strong> registrada com sucesso!
    </v-alert>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                  <v-autocomplete
                  :items="documentos"
                  v-model="documentoSelecionado"
                  color="primary"
                  item-text="descricao"
                  item-value="nome"
                  label="Nome do documento"
                  placeholder="Selecione o documento*"
                  prepend-icon="search"
                  return-object
                  @change="SelecionaDocumento"
                  @click="initializeDocumento()"
                  :rules="ruleRequired"
                  filled
                  outlined
                >
                  <template v-slot:item="{item}">
                      <v-list-item-avatar v-if="item.icone"
                          color="indigo"
                          class="headline font-weight-light white--text"
                        >
                        <v-btn  icon fab><v-icon style="color:white;">add</v-icon></v-btn>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title v-text="item.descricao"></v-list-item-title>
                      </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                  <v-text-field  v-model="editedItemFactura.numeroFatura"  :rules="ruleRequired"  label="Número da Factura*"></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                  <template>
                    <v-menu
                      ref="menuCompra"
                      v-model="menuCompra"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field

                          v-model="editedItemFactura.data"
                          :rules="[v => !!v || 'Campo obrigatorio!']"
                          label="Data de compra*"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="dataFabrico"
                        ref="picker"
                        max="2025-12-31"
                        min="1950-01-01"
                        @change="saveDataCompra"
                      ></v-date-picker>
                    </v-menu>
                    </template>
              </v-col>
              <v-col cols="12" md="4" v-if="(documentoSelecionado !== null) ? documentoSelecionado.idDocumento === 3 : true">
                  <template>
                    <v-menu
                      ref="menuVencimento"
                      v-model="menuVencimento"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field

                          v-model="editedItemFactura.dataVencimento"
                           label="Data de vencimento"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="dataFabrico"
                        ref="picker"
                        max="2025-12-31"
                        min="1950-01-01"
                        @change="saveDataVencimento"
                      ></v-date-picker>
                    </v-menu>
                    </template>
              </v-col>
             <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItemFactura.valorTotal" v-money="money" :rules="ruleRequired" label="Custo de Produtos*" ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItemFactura.custoTransporte" v-money="money" :rules="ruleRequired" label="Custo de Transporte*" ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-select
                    v-model="editedItemFactura.iva"
                    :items="taxa_iva"
                    item-value="percentagem"
                    item-text="descricao"
                    @change="SelecionaIvaPreco()"
                     prepend-icon="search"
                     object-return
                    filled
                     outlined
                    label="Imposto"
                  ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-combobox
                  :items="descricao_isencao_ivaprecoFiltered"
                  v-model="editedItemFactura.motivoIsencao"
                  :rules="ruleRequiredMotivo"
                  item-text="descricao"
                  :disabled="disabilita_ivaPreco"
                   prepend-icon="search"
                   filled
                     outlined
                  label="Motivo de isenção"
                ></v-combobox>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-autocomplete
                  v-model="editedItemFactura.fkFornecedor"
                  :items="fornecedores"
                  :loading="isLoadingForn"
                  :search-input.sync="searchForn"
                  color="primary"
                  item-text="nome"
                  item-value="nome"
                  label="Nome ou Nif do Fornecedor"
                  placeholder="Digite o nome ou nif do Fornecedor"
                   prepend-icon="search"
                  return-object
                  @change="SelecionaFornecedor"
                  @click="Listagem_fornecedores_recentes()"
                  :rules="ruleRequired"
                   filled
                     outlined
                >
                  <template v-slot:item="{item}">
                      <v-list-item-avatar v-if="item.icone"
                          color="indigo"
                          class="headline font-weight-light white--text"
                        >
                        <v-btn  icon fab><v-icon style="color:white;">add</v-icon></v-btn>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title v-text="item.nome"></v-list-item-title>
                      </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-col>
               <v-col cols="12" sm="6" md="4">
                <template>
                  <v-file-input
                    v-model="editedItemFactura.file"
                    color="#006699"
                    counter
                    label="Anexar o Ficheiro da Fatura"
                    placeholder="Selecione o ficheiro"
                    prepend-icon="attach_file"
                    outlined
                    :show-size="1000"
                  >
                    <template v-slot:selection="{ index, text }">
                      <v-chip
                        v-if="index < 2"
                        color="#006699"
                        dark
                        label
                        small
                      >
                        {{ text }}
                      </v-chip>

                      <span
                        v-else-if="index === 2"
                        class="overline grey--text text--darken-3 mx-2"
                      >
                        +{{ ficheiroFatura.length - 2 }} File(s)
                      </span>
                    </template>
                  </v-file-input>
                  </template>
            </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItemFactura.descricao"  label="Observação" ></v-text-field>
              </v-col>
               <v-col cols="12" sm="6" md="4">
                <v-text-field label="Desconto" v-model="editedItemFactura.desconto" :rules="ruleRequired" v-money="money"></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
       <!-- <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" style="color:white;"   @click="SaveFactura()">Guardar</v-btn>
          <v-btn color="red darken-1"   style="color:white;" @click="reset()">Cancelar</v-btn>
        </v-card-actions> -->
      </v-card>
  </v-row>
  <v-row>
     <v-card style="margin:auto;margin-top:1px;" width="1200">
         <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                   <v-select
                      :items="meiosPagamento"
                      v-model="editedItemFactura.meioPagamento"
                      :rules="ruleRequired"
                      item-text="descricao"
                      item-value="idMeioPagamento"
                      filled
                      label="Meios de Pagamento"
                      @change="SelecionaMeioPagamento()"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="3" v-if="Showprestacoes">
                <v-text-field v-model="editedItemFactura.intervalopagamento" :rules="ruleNumber" label="Intervalo de Pagamento(dias)" ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3" v-if="Showprestacoes">
                <v-text-field v-model="editedItemFactura.nprestacoes" :rules="ruleNumber" label="Nº prestações" ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
         <v-card-actions style="margin-top:-80px;">
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" style="color:white;"   @click="SaveFactura()">Submeter</v-btn>
          <v-btn color="red darken-1"   style="color:white;" @click="reset()">Cancelar</v-btn>
        </v-card-actions>
     </v-card>
  </v-row>
</v-form>
  </div>
</div>
</div>
</template>
My CRUD
<script>

import axios from '../../plugins/axios'
import utilitarios from '../../plugins/utilitarios'
import { mask } from 'vue-the-mask'
import { VMoney } from 'v-money'
import Swal from 'sweetalert2'
const ls = require('local-storage')
// const axios = require('../plugins/axios')
export default {
  directives: { mask, money: VMoney },
  data: () => ({
    money: {
      decimal: ',',
      thousands: '.',
      suffix: ' Kz',
      precision: 2,
      masked: false
    },
    editedItemFornecedor: {
      nome: '',
      nif: '',
      tipoFornecedor: '',
      morada: '',
      telefone1: '',
      telefone2: '',
      email: '',
      observacao: ''
    },
    editedItemFornecedorDefault: {
      nome: '',
      nif: '',
      tipoFornecedor: '',
      morada: '',
      telefone1: '',
      telefone2: '',
      email: '',
      observacao: ''
    },
    overlay: false,
    valorDisponivel: '',
    Showprestacoes: false,
    dialogFatura: false,
    menuCompra: null,
    isLoading_: false,
    isLoadingFt: false,
    dialogFornecedor: false,
    isLoadingForn: false,
    search: '',
    searchForn: '',
    searchNF: '',
    menuFab: null,
    menuExp: null,
    menuVencimento: null,
    dataExpiracao: '',
    dataFabrico: '',
    dataCompra: '',
    valid: true,
    valid1: true,
    files: [],
    taxa_iva: [],
    faturas: [],
    fornecedores: [],
    valorFatura: 0,
    meiosPagamento: [],
    documentos: [],
    descricao_isencao_iva: [],
    descricao_isencao_ivaprecoFiltered: [],
    documentoSelecionado: null,
    taxa_ivaPrecoSelected: null,
    dataCompraSelected: null,
    disabilita_ivaPreco: true,
    produtos: [],
    disabilitaDisponivel: true,
    disabilitaQtd: true,
    alert: false,
    alertF: false,
    colorAlert: 'color:green;',
    iconAlert: 'done',
    alertType: 'success',
    msgAlert: '',
    operacoesStocks:
    [
      { descricao: 'Entrada de Stock' },
      { descricao: 'Saida de Stock' }
    ],
    disponiblidade:
    [
      { id: 1, descricao: 'Não disponível' },
      { id: 2, descricao: 'Disponível' }
    ],
    y: 'top',
    text: 'mensagem nao setada.',
    //  timeout: 4000,
    ruleRequiredMotivo: [value => !!value || 'campo obrigatorio'],
    ruleRequired: [value => !!value || 'campo obrigatorio'],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value =>
        (value || '').length <= 50 || 'O máximo número de carácters atigidos',

      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],
    ruleBI: [

      value => value.length === 16 || 'Minimo de caracteres exigido( 16 ).'
    ],
    ruleNumber: [
      value => !!value || 'campo obrigatório.',
      value => {
        const pattern = /^[0-9]*$/
        return pattern.test(value) || 'O valor deve ser numerico.'
      }
    ],
    ruleNumberNObrigatorio: [
      value => {
        const pattern = /^[0-9]*$/
        return pattern.test(value) || 'O valor deve ser numerico.'
      }
    ],
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      value => value.length <= 50 || 'O máximo número de carácters atigidos',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    ],

    msg: '',
    editedIndex: -1,
    municSelectedForComb: null,
    proviSelectedForComb: null,
    editedItem: {
      dataExpiracao: '',
      dataFabrico: '',
      produto: null,
      lote: '',
      quantidade: 0,
      operacao: '',
      observacao: '',
      fornecedor: null,
      custoCompra: '',
      custoTransporte: '',
      precoUnitario: 0,
      impostoIva: '',
      motivoIsencao: '',
      numeroFatura: '',
      ficheiroFatura: [],
      qtdVenda: 0,
      disponivel: '',
      faturaCompra: null,
      meioPagamento: null,
      intervalopagamento: '',
      nprestacoes: ''
    },
    editedItemDefault: {
      dataExpiracao: '',
      dataFabrico: '',
      produto: null,
      lote: '',
      quantidade: 0,
      operacao: '',
      observacao: '',
      fornecedor: null,
      custoCompra: 0,
      custoTransporte: 0,
      precoUnitario: 0,
      impostoIva: '',
      motivoIsencao: '',
      numeroFatura: '',
      ficheiroFatura: [],
      qtdVenda: 0,
      disponivel: '',
      meioPagamento: null,
      intervalopagamento: '',
      nprestacoes: ''
    },
    editedItemFactura: {
      numeroFatura: '',
      descricao: '',
      iva: '',
      motivoIsencao: '',
      data: '',
      valorTotal: '',
      custoTransporte: '',
      file: null,
      fkFornecedor: '',
      desconto: '',
      dataVencimento: ''
    },
    editedItemFacturaDefault: {
      numeroFatura: '',
      descricao: '',
      iva: '',
      motivoIsencao: '',
      data: '',
      valorTotal: '',
      custoTransporte: '',
      file: null,
      fkFornecedor: ''
    },
    tipoFornecedor:
    [
      { descricao: 'Muito Bom' },
      { descricao: 'Bom' },
      { descricao: 'Médio' }
    ]
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Inser novo Estudante' : 'Editar dados de Estudante'
    },
    loggedUserName () {
      return ls.get('nomeUsuario')
    },
    idclasse () {
      return this.$store.state.idclasse
    },
    computeddatanascimento () {
      // eslint-disable-next-line no-undef
      return this.editedItem.datanascimento ? moment(this.editedItem.datanascimento).format('dddd, MMMM Do YYYY') : ''
    },
    computedDateFormattedDatefns () {
      // eslint-disable-next-line no-undef
      return this.date ? format(this.date, 'dddd, MMMM Do YYYY') : ''
    },
    textMessage () {
      return this.$store.state.textMessage
    },
    classMessage () {
      return this.$store.state.classMessage
    },
    hasMessage () {
      return this.$store.state.hasMessage
    },

    ListaActividades () {
      return ls.get('lista_actividades')
    },

    returnImagem () {
      return this.imageData
    }

  },

  watch: {
    menuFab (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menuExp (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menuCompra (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    estudantes () {
      this.isLoading = false
      this.$store.state.isloading = false
    },
    dialog (val) {
      val || this.close()
    },
    model (val) {
      if (val.length > 1) {
        this.$nextTick(() => this.model.pop())
      }
    },
    search (val) {
      // Items have already been loaded
      if (val.length >= 1) {
      // Items have already been requested
        if (!this.produtos.filter(t => t.descricao.includes(val)).length) {
          this.produtos = []
          return this.initializeProdutos(val)
        }
      }

      if (val.length >= 1) { return this.initializeProdutos(val) }
    },
    searchForn (val) {
      // Items have already been loaded
      if (val.length >= 2) {
      // Items have already been requested
        if (!this.fornecedores.filter(t => t.nome.includes(val) || t.nif.includes(val)).length) {
          this.fornecedores = []
          return this.PesquisarFornecedores(val)
        }
      }

      if (val.length >= 2) { return this.PesquisarFornecedores(val) }
    },
    searchNF (val) {
      // Items have already been loaded
      if (val.length >= 1) {
      // Items have already been requested
        if (!this.faturas.filter(t => t.referencia.includes(val)).length) {
          this.faturas = []
          return this.PesquisarFaturas(val)
        }
      }

      if (val.length >= 1) { return this.PesquisarFaturas(val) }
    }

  },

  created () {
    // check if classe has been selected otherwise send back to painel to select
    this.initializeMeiosPagamento()
    this.initializeTaxaIva()
    this.initializeIsencaoIva()
  },

  methods: {
    previewImage: function (event) {
      // Reference to the DOM input element
      var input = event.target
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader()
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageData = e.target.result
        }
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0])
      }
    },

    async initializeProdutos (searchBy) {
      try {
        //   let  payload =""
        this.isLoading_ = true
        this.produtos = await axios
          .get('/produtosFindAll/' + searchBy)
          .then(res => res.data)
        this.isLoading_ = false
      } catch (error) {
        this.isLoading_ = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async PesquisarFornecedores (searchBy) {
      try {
        //   let  payload =""
        this.isLoadingForn = true
        this.fornecedores = await axios
          .get('/FornecedorFindAll/' + searchBy)
          .then(res => res.data)
        this.isLoadingForn = false
      } catch (error) {
        this.isLoadingForn = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    back () {
      this.$router.push('Novo-Stock')
      this.$store.state.fromStock = false
    },

    async Listagem_fornecedores_recentes () {
      try {
        //   let  payload =""
        this.overlay = true
        this.fornecedores = await axios
          .get('/Listagem_ultimos_fornecedores')
          .then(res => res.data)
        this.fornecedores.push({ nome: 'Novo Fornecedor', icone: true, pkFornecedor: 0 })
        this.overlay = false
      } catch (error) {
        this.overlay = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async  PesquisarFaturas (val) {
      try {
        //   let  payload =""
        this.isLoadingFt = true
        this.faturas = await axios
          .get('/FaturaFindAll/' + val)
          .then(res => res.data)
        this.isLoadingFt = false
      } catch (error) {
        this.isLoadingFt = false
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initializeTipoProdutos () {
      try {
        //   let  payload =""
        this.isLoading = true
        this.tipoProdutos = await axios
          .get('/tipoProdutoFindall')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // combo qua depende de outra combo
    async initializeMercadoria () {
      try {
        //   let  payload =""
        this.isLoading = true
        this.mercadorias = await axios
          .get('/mercadoriaFindall')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // comb
    async initializeArmazem () {
      try {
        //   let  payload =""
        this.isLoading = true
        this.armazem = await axios
          .get('/armazemFindall')
          .then(res => res.data)
        console.log(this.armazem)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // comb
    async initializeFamiliaProduto () {
      try {
        //   let  payload =""
        this.isLoading = true
        this.familiaProduto = await axios
          .get('/FamiliaProdutoFindall')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // comb

    async initializeDocumento () {
      try {
        this.overlay = true
        this.documentos = await axios
          .get('/documentos')
          .then(res => res.data)

        this.overlay = false
      } catch (error) {
        this.overlay = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async initializeTaxaIva () {
      try {
        //   let  payload =""
        this.isLoading = true
        this.taxa_iva = await axios
          .get('/TaxaIvaFindall')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // comb
    async initializeIsencaoIva () {
      try {
        //   let  payload =""
        this.isLoading = true
        this.descricao_isencao_iva = await axios
          .get('/IsencaoIvaFindall')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // comb

    async initializePrecosDescricao () {
      try {
        //   let  payload =""
        this.isLoading = true
        this.precosExtensao = await axios
          .get('/precosExtensaoFindall')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // comb

    async initializeMeiosPagamento () {
      try {
        //   let  payload =""
        this.overlay = true
        this.meiosPagamento = await axios
          .get('/meiosPagamento')
          .then(res => res.data)
        this.overlay = false
      } catch (error) {
        this.overlay = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // comb

    SelecionaDisponibilidade () {
      if (this.editedItem.disponivel === 2) { this.disabilitaQtd = false } else this.disabilitaQtd = true
    },

    SelecionaIvaVenda () {
      if (this.taxaIvaVendaSelected !== null) {
        if (this.taxaIvaVendaSelected === 0) {
          this.descricao_isencao_ivaFiltered = this.descricao_isencao_iva
          this.disabilita_ivaVenda = false
        } else {
          this.disabilita_ivaVenda = true
          this.descricao_isencao_ivaFiltered = []
        }
      }
    },

    SelecionaDocumento () {

    },

    SelecionaOperacao () {
      if (this.editedItem.operacao === 'Entrada de Stock') {
        this.disabilitaDisponivel = false
      } else {
        this.disabilitaDisponivel = true
      }
    },

    SelecionaProduto () {
      console.log(this.editedItem.produto)
    },

    SelecionaFornecedor () {
      if (this.editedItemFactura.fkFornecedor.pkFornecedor === 0) {
        this.editedItemFactura.fkFornecedor = null
        this.dialogFornecedor = true
      }
    },

    SelecionaMeioPagamento () {
      if (this.editedItemFactura.meioPagamento === 5) {
        this.Showprestacoes = true
      } else {
        this.Showprestacoes = false
        this.editedItemFactura.nprestacoes = ''
        this.editedItemFactura.intervalopagamento = ''
      }
    },

    SelecionaIvaCompra () {
      if (this.taxaIvaCompraSelected !== null) {
        if (this.taxaIvaCompraSelected === 0) {
          this.descricao_isencao_compraFiltered = this.descricao_isencao_iva
          this.disabilita_ivaCompra = false
        } else {
          this.disabilita_ivaCompra = true
          this.descricao_isencao_compraFiltered = []
        }
      }
    },

    SelecionaIvaPreco () {
      if (this.editedItemFactura.iva !== null) {
        if (this.editedItemFactura.iva === 0) {
          this.descricao_isencao_ivaprecoFiltered = this.descricao_isencao_iva
          this.disabilita_ivaPreco = false
        } else {
          this.disabilita_ivaPreco = true
          this.descricao_isencao_ivaprecoFiltered = []
          this.ruleRequiredMotivo = true
        }
        this.CalculaPreComIva(this.editedItemFactura.iva / 100)
      }
    },

    async SaveFornecedor () {
      if (this.$refs.form.validate()) {
        let params =
          {
            pkFornecedor: 0,
            nome: this.editedItemFornecedor.nome,
            nif: this.editedItemFornecedor.nif,
            tipoFornecedor: this.editedItemFornecedor.tipoFornecedor,
            morada: this.editedItemFornecedor.morada,
            telefone1: this.editedItemFornecedor.telefone1,
            telefone2: this.editedItemFornecedor.telefone2,
            email: this.editedItemFornecedor.email,
            observacao: this.editedItemFornecedor.observacao
          }
        try {
        //   let  payload =""
          let msg = await axios
            .post('/fornecedorInsertOrUpdate', params)
            .then(res => res.data)

          if (msg.affectedRows >= 1) {
            this.showAlertSucessF()
            this.LimparFornecedor()
            this.Listagem_fornecedores_recentes().then(() => {
              this.editedItemFactura.fkFornecedor = this.fornecedores[0]
            })
          }
        } catch (error) {
          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        }
      }
    },

    LimparFornecedor () {
      this.editedItemFornecedor = this.editedItemFornecedorDefault
    },

    async  SelecionaFatura () {
      try {
        //   let  payload =""
        let result = await axios
          .get('/SomaVendaTotalPorFatura/' + this.editedItem.faturaCompra.pkFaturaCompra)
          .then(res => res.data)
        if (result.length) {
          this.valorFatura = utilitarios.IntegerToMoneyValue(this.editedItem.faturaCompra.totalFatura)
          this.valorDisponivel = utilitarios.IntegerToMoneyValue(result[0].valorTotal)
        }
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async   Save () {
      if (this.$refs.form.validate()) {
        let params =
        {
          pkStock: 0,
          fkProduto: this.editedItem.produto.pkProduto,
          produto: this.editedItem.produto.descricao,
          lote: this.editedItem.lote,
          quantidade: this.editedItem.quantidade,
          dataFab: this.editedItem.dataFabrico,
          dataExp: this.editedItem.dataExpiracao,
          operacao: this.editedItem.operacao,
          observacao: this.editedItem.observacao,
          fkFornecedor: this.editedItem.fornecedor.pkFornecedor,
          fornecedor: this.editedItem.fornecedor.nome,
          nif: this.editedItem.fornecedor.nif,
          custoCompra: utilitarios.MoneyValueToInteger(this.editedItem.custoCompra),
          custoTransporte: utilitarios.MoneyValueToInteger(this.editedItem.custoTransporte),
          precoUnitario: utilitarios.MoneyValueToInteger(this.editedItem.precoUnitario),
          impostoIva: this.editedItem.impostoIva,
          motivoIsencao: this.editedItem.motivoIsencao,
          fkFatura: this.editedItem.faturaCompra.pkFaturaCompra,
          qtdVenda: this.editedItem.qtdVenda,
          disponiblidadeVenda: this.editedItem.disponivel,
          custoCompraString: this.editedItem.custoCompra,
          custoTransporteString: this.editedItem.custoTransporte,
          stockMinimo: this.editedItem.produto.stock_min,
          stockMaximo: this.editedItem.produto.stock_max
        }

        // === Calcula a soma Total
        let valor = utilitarios.MoneyValueToInteger(this.valorDisponivel)
        let result = parseFloat(valor) + parseFloat(params.custoCompra)
        let valorFatura = utilitarios.MoneyValueToInteger(this.valorFatura)
        if (valorFatura >= result) {
          try {
          //   let  payload =""
            let msg = await axios
              .post('/stockInsertOrUpdate', params)
              .then(res => res.data)

            if (msg.affectedRows >= 1) {
              this.showAlertSucess()
              this.valorDisponivel = utilitarios.IntegerToMoneyValue(result)
              this.Limpar()
            }
          } catch (error) {
            this.text = error
            this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
          }
        } else {
          this.showAlertValorCompraAtingida()
        }
      }
    },

    showAlertValorCompraAtingida () {
      this.alert = true
      this.colorAlert = 'color:red;'
      this.iconAlert = 'warning'
      this.alertType = 'warning'
      this.msgAlert = 'Valor de compra atingido!'
      setTimeout(() => {
        this.alert = false
      }, 4000)
    },

    showAlertSucessF () {
      this.alertF = true
      this.colorAlert = 'color:green;'
      this.iconAlert = 'done'
      this.alertType = 'success'
      this.msgAlert = 'Fornecedor  registrado com sucesso!'
      setTimeout(() => {
        this.alertF = false
        this.dialogFornecedor = false
      }, 1000)
    },
    showAlertSucess () {
      this.alert = true
      setTimeout(() => {
        this.alert = false
      }, 4000)
    },

    // METHODO FOR VALIDATION
    validate () {
      if (this.$refs.form.validate()) {

      } else {
        console.log('elso foraaa')
      }
    },
    reset () {
      this.$refs.form.reset()
      this.Limpar()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },

    SelecionaTipoServico () {
      if (this.tipoProdutoSelected !== null) {
        this.mercadoriasFiltered = this.mercadorias.filter(f => f.fk_tipoProduto === this.tipoProdutoSelected)
        console.log(this.mercadorias)

        this.mercadoria_disable = (this.tipoProdutoSelected !== 1)
      }
    },
    savePreco () {
      if (this.$refs.form.validate()) {
        let params =
          {
            descricaoPreco: (this.model.descricao !== undefined) ? this.model.descricao : this.model,
            margem: this.margemPreco,
            precoSemIva: this.ObterValorFormatado(this.precoSemIva),
            iva: this.taxa_ivaPrecoSelected,
            motivoIsencao: this.motivoIsencao,
            predifinido: this.predifinido,
            precoComIva: this.precoComIva
          }

        this.tabelas_preco.push(params)
        this.dialog = false
      }
    },

    async saveProduto () {
      if (this.$refs.form.validate()) {
        if (this.tabelas_preco.length) {
          let params =
        {
          descricao: this.descricaoProduto,
          descricaoReduzida: this.descricaoReduzida,
          codigoBarra: this.codigoBarraSelected,
          armazem: this.armazemSelected,
          tipoProduto: this.tipoProdutoSelected,
          mercadoria: this.mercadoriaSelected,
          familia: this.familiaSelected,
          precoCusto: this.precoCustoSelected,
          precoComIva: this.precoComIvaInteiro,
          precoSemIva: this.precoSemIva,
          margem: this.margemPreco,
          iva: this.taxa_ivaPrecoSelected,
          isencao: this.motivoIsencao,
          descricaoPreco: (this.model.descricao !== undefined) ? this.model.descricao : this.model,
          pkPreco: (this.model.descricao !== undefined) ? this.model.pkPreco : 0
        }

          try {
            //   let  payload =""
            this.isLoading = true
            let msg = await axios
              .post('/produtoAdd', params)
              .then(res => res.data)

            if (!msg.length) {
              this.alert = true
              this.colorAlert = 'color:green;'
              this.iconAlert = 'done'
              this.alertType = 'success'
              this.msgAlert = 'Produto registrado com sucesso!'
              setTimeout(() => {
                this.alert = false
              }, 4000)
              this.reset()
            }
          } catch (error) {
            this.isLoading = false

            this.text = error
            this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
          }
        } else {
          this.alert = true
          this.colorAlert = 'color:red;'
          this.iconAlert = 'warning'
          this.alertType = 'error'
          this.msgAlert = 'Os campos relacionados ao preço do produto devem ser preenchidos!'
          setTimeout(() => {
            this.alert = false
          }, 4000)
        }
      }
    },

    Limpar () {
      this.editedItem = this.editedItemDefault
      this.editedItemFactura = this.editedItemFacturaDefault
      this.$refs.form.resetValidation()
    },

    CalculaPreComIva (valor) {
      let valorIva = parseInt(this.precoSemIva) * valor
      let valorFinal = parseInt(this.precoSemIva) + valorIva
      this.precoComIva = valorFinal
      this.precoComIva = this.ObterValorFormatado(valorFinal)
      this.precoComIvaInteiro = valorFinal
    },

    ObterValorFormatado (valor) {
      let formated = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'AOA' }).format(valor)
      return formated.toString().replace('AOA', '')
    },
    saveDataFabrico (date) {
      this.$refs.menuFab.save(date)
      this.editedItem.dataFabrico = date
    },
    saveDataExpiracao (date) {
      this.$refs.menuExp.save(date)
      this.editedItem.dataExpiracao = date
    },
    saveDataCompra (date) {
      this.$refs.menuCompra.save(date)
      this.editedItemFactura.data = date
    },
    saveDataVencimento (date) {
      this.$refs.menuVencimento.save(date)
      this.editedItemFactura.dataVencimento = date
    },
    async  SaveFactura () {
      if (this.$refs.form.validate()) {
        this.overlay = true
        let params =
         {
           identificador: this.editedItemFactura.numeroFatura,
           descricao: this.editedItemFactura.descricao,
           valorTotal: utilitarios.MoneyValueToInteger(this.editedItemFactura.valorTotal),
           custoTransporte: utilitarios.MoneyValueToInteger(this.editedItemFactura.custoTransporte),
           fileName: (this.editedItemFactura.file !== null) ? this.editedItemFactura.file.name : this.editedItemFactura.file,
           dataCompra: this.editedItemFactura.data,
           fk_fornecedor: this.editedItemFactura.fkFornecedor.pkFornecedor,
           iva: this.editedItemFactura.iva,
           motivoIsencao: this.editedItemFactura.motivoIsencao,
           meioPagamento: this.editedItemFactura.meioPagamento,
           nprestacoes: this.editedItemFactura.nprestacoes,
           intervalopagamento: this.editedItemFactura.intervalopagamento,
           documento: this.documentoSelecionado.idDocumento,
           dataValidade: this.editedItemFactura.dataVencimento
         }

        try {
          //   let  payload =""
          this.isLoading = true
          let msg = await axios
            .post('/FacturaCompraAdd', params)
            .then(res => res.data)
          if (msg.affectedRows >= 1) {
             Swal.fire('Factura registrada com sucesso.','','success')
             this.Limpar()
          }
          this.overlay = false
        } catch (error) {
          this.isLoading = false
          this.overlay = false
          Swal.fire('Ocorreu um erro ao tentar efectuar a operação','','error')
        }
      } else {
        console.log('funciona')
      }
    }
  }
}
</script>
<style scoped>

.btn_space {
  margin-bottom:5px;
}

.btn_add_align {
  margin-top:10px;
}
.file-upload-form, .image-preview {
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
    padding: 20px;
}
img.preview {
    background-color: white;
    border: 1px solid #DDD;
    padding: 5px;
}

</style>
